webpackJsonp([39],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cb_error__ = __webpack_require__(18);




var CBNotification = function () {
  function CBNotification(type, pl) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CBNotification);

    this.type = type;
    this.showIcon = true;
    this.constructMessage(pl);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CBNotification, [{
    key: "constructMessage",
    value: function constructMessage(pl) {
      if (this.type == "error") {
        this.isDismissible = pl.isDismissible;
        if (pl instanceof __WEBPACK_IMPORTED_MODULE_2__utils_cb_error__["a" /* default */]) {
          this.message = pl.reviewScreenMessage();
          this.isDismissible = true;
        } else {
          this.message = pl.message;
          this.showIcon = false;
        }
        this.errorSource = pl;
      }
    }
  }]);

  return CBNotification;
}();

/* harmony default export */ __webpack_exports__["a"] = (CBNotification);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var RequestTransformer = function () {
  function RequestTransformer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RequestTransformer);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RequestTransformer, null, [{
    key: 'collectPaymentExistingPaymentId',
    value: function collectPaymentExistingPaymentId(getters, payment_source_id) {
      var output = {
        currency_code: getters.currency_code,
        payment_source_id: payment_source_id,
        amount: getters.amountToBePaid
      };

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flattenMulti(getters.selected_invoices.map(function (i) {
        return { invoice_id: i.id };
      }), 'invoice_allocations'));
      return output;
    }
  }, {
    key: 'collectPaymentNewSource',
    value: function collectPaymentNewSource(store, data, _ref) {
      var replace_primary_payment_source = _ref.replace_primary_payment_source,
          retain_payment_source = _ref.retain_payment_source;

      var output = {
        currency_code: store.getters.currency_code,
        amount: store.getters.amountToBePaid,
        replace_primary_payment_source: replace_primary_payment_source,
        retain_payment_source: retain_payment_source
      };

      if (data.tmp_token) {
        data['payment_method[tmp_token]'] = data.tmp_token;
        delete data.tmp_token;
        data['payment_method[type]'] = data.type;
        delete data.type;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.createPaymentSourceUsingTmpToken(store.state, store.getters, data, replace_primary_payment_source, true));
      } else if (data.type == 'direct_debit' && !data.tmp_token) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.createBankAccountPaymentSource(store.state, store.getters, data, replace_primary_payment_source, true));
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.createCardPaymentSource(store.state, store.getters, data, replace_primary_payment_source, true));
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flattenMulti(store.getters.selected_invoices.map(function (i) {
        return { invoice_id: i.id };
      }), 'invoice_allocations'));

      return output;
    }
  }, {
    key: 'estimateRequest',
    value: function estimateRequest(state, rootState, getters) {
      var orderItem = state.cart.orderItems[0];
      var output = this.baseEstimateRequest(orderItem, getters);
      output["customer[vat_number]"] = getters.customer_data.vat_number;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flatten(rootState.customer.billing_address, 'billing_address'), this.flatten(state.shipping_address, 'shipping_address'));

      return output;
    }
  }, {
    key: 'estimateGiftRequest',
    value: function estimateGiftRequest(state, rootState, getters) {
      var orderItem = state.cart.orderItems[0];
      var output = this.baseGiftRequest(orderItem, getters);
      output["customer[vat_number]"] = getters.customer_data.vat_number;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flatten(rootState.customer.billing_address, 'billing_address'), this.flatten(state.shipping_address, 'shipping_address'));

      return output;
    }
  }, {
    key: 'estimateRequestForCustomer',
    value: function estimateRequestForCustomer(state, getters) {
      var orderItem = state.cart.orderItems[0];
      var output = this.baseEstimateRequest(orderItem, getters);

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flatten(state.shipping_address, 'shipping_address'));

      return output;
    }
  }, {
    key: 'estimateGiftRequestForCustomer',
    value: function estimateGiftRequestForCustomer(state, getters) {
      var orderItem = state.cart.orderItems[0];
      var output = this.baseGiftRequest(orderItem, getters);

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flatten(state.shipping_address, 'shipping_address'));

      return output;
    }
  }, {
    key: 'estimateRequestForUpdateSubscription',
    value: function estimateRequestForUpdateSubscription(state, rootState, getters) {
      var orderItem = state.cart.orderItems[0];
      var output = this.baseEstimateRequest(orderItem, getters);

      //removing expired coupon
      var coupon_id = output["coupon_ids[0]"];
      if (coupon_id) {
        var cp = orderItem.coupon_list && orderItem.coupon_list.filter(function (c) {
          return c.code == coupon_id;
        })[0];
        if (cp && cp.details && cp.details.status != "active") {
          delete output["coupon_ids[0]"];
        }
      }

      if (state.extend_sub_billing_cycle) {
        output["billing_cycles"] = state.extend_sub_billing_cycle;
      }

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.flatten(state.shipping_address, 'shipping_address'));
      return output;
    }
  }, {
    key: 'baseEstimateRequest',
    value: function baseEstimateRequest(orderItem, getters) {
      var output = this.baseSubscriptionRequest(orderItem);
      output.exclude_address_tax_calculation = getters.excludeAddressForTaxCalculation();
      return output;
    }
  }, {
    key: 'baseGiftRequest',
    value: function baseGiftRequest(orderItem) {
      var output = {
        plan_id: orderItem.plan.id,
        plan_quantity: orderItem.plan.quantity
      };

      var addons = this.flattenMulti(orderItem.addons, 'addons');
      var coupons = {};
      if (orderItem.coupon) {
        var cp = orderItem.coupon_list && orderItem.coupon_list.filter(function (c) {
          return c.id == orderItem.coupon;
        })[0];
        coupons["coupon_ids[0]"] = cp && cp.code || orderItem.coupon;
      }

      if (orderItem.replace_addon_list) {
        output["replace_addon_list"] = true;
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.flatten(output, 'subscription'), addons, coupons);
    }
  }, {
    key: 'baseSubscriptionRequest',
    value: function baseSubscriptionRequest(orderItem) {
      var output = {
        plan_id: orderItem.plan.id,
        plan_quantity: orderItem.plan.quantity
      };

      var addons = this.flattenMulti(orderItem.addons, 'addons');
      if (orderItem.coupon) {
        var cp = orderItem.coupon_list && orderItem.coupon_list.filter(function (c) {
          return c.id == orderItem.coupon;
        })[0];
        output["coupon_ids[0]"] = cp && cp.code || orderItem.coupon;
      }

      if (orderItem.replace_coupon_list) {
        output["replace_coupon_list"] = true;
      }

      if (orderItem.replace_addon_list) {
        output["replace_addon_list"] = true;
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, addons);
    }
  }, {
    key: 'updateSubscription',
    value: function updateSubscription(state) {
      return this.createSubscriptionForCustomer(state, true);
    }
  }, {
    key: 'createSubscriptionForCustomer',
    value: function createSubscriptionForCustomer(state, skipSubscriptionLevel, masterParams) {
      var output = {};
      var orderItem = state.order.cart.orderItems[0];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, this.baseSubscriptionRequest(orderItem));
      var addons = this.flattenMulti(orderItem.addons, 'addons');
      var shippingAddress = this.flatten(state.order.shipping_address, 'shipping_address');
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, addons, shippingAddress, state.order.subscription);
      if (!skipSubscriptionLevel && state.order.pm_subscription_level) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, { payment_source_id: state.order.payment_method.id });
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, { tos_agreed: state.order.tos_agreed });
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, { "payless_checkout": state.config.recaptcha_checkout });
      if (masterParams) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(output, { "recaptcha_response": masterParams.recaptcha_response });
      }
      return output;
    }
  }, {
    key: 'createSubscription',
    value: function createSubscription(state, masterParams) {
      var subscription = this.createSubscriptionForCustomer(state, true, masterParams);
      // May need to change the logic if bank account needs to be supported
      if (!state.config.recaptcha_checkout) {
        if (state.order.payment_method.type == "card" && !state.order.payment_method.tmp_token) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(subscription, this.flatten(state.order.payment_method, 'card'));
        } else if (state.order.payment_method.type == "direct_debit" && !state.order.payment_method.tmp_token) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(subscription, this.flatten(state.order.payment_method, 'bank_account'));
        } else {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(subscription, this.flatten(state.order.payment_method, 'payment_method'));
        }
      }

      if (masterParams) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(subscription, { "recaptcha_response": masterParams.recaptcha_response });
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(subscription, this.flatten(state.customer.data, 'customer'), this.flatten(state.customer.billing_address, 'billing_address'), this.flatten(state.order.shipping_address, 'shipping_address'), { "payless_checkout": state.config.recaptcha_checkout });
    }
  }, {
    key: 'createCardPaymentSource',
    value: function createCardPaymentSource(state, getters, data, replacePrimary, skipReplacePaymentSource) {
      var output = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.flatten(data, 'card'), {
        customer_id: state.auth.customer_handle
      });

      if (!skipReplacePaymentSource) {
        output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported;
      }

      return output;
    }
  }, {
    key: 'createBankAccountPaymentSource',
    value: function createBankAccountPaymentSource(state, getters, data, replacePrimary, skipReplacePaymentSource) {
      var output = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.flatten(data, 'bank_account'), {
        customer_id: state.auth.customer_handle
      });
      output["issuing_country"] = output["bank_account[issuing_country]"];
      delete output["bank_account[issuing_country]"];

      if (!skipReplacePaymentSource) {
        output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported;
      }

      return output;
    }
  }, {
    key: 'createPaymentSourceUsingTmpToken',
    value: function createPaymentSourceUsingTmpToken(state, getters, data, replacePrimary, skipReplacePaymentSource) {
      var output = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data, { customer_id: state.auth.customer_handle });

      if (!skipReplacePaymentSource) {
        output["replace_primary_payment_source"] = replacePrimary || !getters.mpm_supported;
      }
      return output;
    }
  }, {
    key: 'updatePaymentMethod',
    value: function updatePaymentMethod(data) {
      return this.flatten(data, 'payment_method');
    }
  }, {
    key: 'flattenMulti',
    value: function flattenMulti(items, name) {
      if (!items) return {};
      return items.reduce(function (o, item, index) {
        // Rethink whether should we  whitelist params
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).filter(function (i) {
          return ['id', 'quantity', 'invoice_id'].indexOf(i) > -1;
        }).forEach(function (keyName) {
          o[name + '[' + keyName + '][' + index + ']'] = item[keyName];
        });
        return o;
      }, {});
    }
  }, {
    key: 'flatten',
    value: function flatten(data, name) {
      if (!data) return {};
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).reduce(function (o, key) {
        o[name + '[' + key + ']'] = data[key];
        return o;
      }, {});
    }
  }, {
    key: 'fetchResourceName',
    value: function fetchResourceName(paramName) {
      if (paramName == "customer[vat_number]") {
        return "billing_address";
      }
      var matchedContents = paramName.match(/(.*)\[(.*)\]/);
      return matchedContents && matchedContents[1];
    }
  }, {
    key: 'fetchParamNameWithoutResource',
    value: function fetchParamNameWithoutResource(paramName) {
      var matchedContents = paramName.match(/(.*)\[(.*)\]/);
      return matchedContents && matchedContents[2] || paramName;
    }
  }, {
    key: 'isNumber',
    value: function isNumber(value) {
      return typeof value === 'number' && !isNaN(Number(value));
    }
  }, {
    key: 'isDate',
    value: function isDate(date) {
      var dateFormat = /^\d{4}-\d{2}-\d{2}$/;
      return dateFormat.test(date) && new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
    }
  }, {
    key: 'getTimestampFromDate',
    value: function getTimestampFromDate(d) {
      if (this.isDate(d)) {
        //should always return as Number
        return new Date(d).getTime() / 1000;
      }
      return d;
    }
  }, {
    key: 'getDateFromTimestamp',
    value: function getDateFromTimestamp(t) {
      var d = new Date(Number(t) * 1000);
      if (!!t && this.isNumber(t) && !isNaN(d)) {
        return d.toISOString().slice(0, 10);
      }
      return t;
    }
  }]);

  return RequestTransformer;
}();

/* harmony default export */ __webpack_exports__["a"] = (RequestTransformer);

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_transformer__ = __webpack_require__(13);




var CbError = function () {
  function CbError(status, response, exceptionType, store) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CbError);

    this.status = status;
    var tmp = this.checkForWebParamException(response);
    this._source = tmp ? tmp : response;

    if (exceptionType) {
      this.exceptionType = exceptionType;
    } else {
      this.exceptionType = this._source.param ? "cb_param" : "cb";
    }
    this.fillValues(store);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CbError, [{
    key: "checkForWebParamException",
    value: function checkForWebParamException(response) {
      if (response.errors && response.errors[1] && response.errors[1].param) {
        return {
          "param": response.errors[1].param,
          "error_msg": response.errors[1].message
        };
      }
    }
  }, {
    key: "fillValues",
    value: function fillValues(store) {
      if (this.isParamException()) {
        this.fillParamException(store);
        this.modifyParamMessages(store);
      } else {
        this.fillException();
      }
    }
  }, {
    key: "fillParamException",
    value: function fillParamException(store) {
      // TODO check if this can be userd
      this.paramMessage = this._source.error_msg;
      this.paramName = __WEBPACK_IMPORTED_MODULE_2__utils_transformer__["a" /* default */].fetchParamNameWithoutResource(this._source.error_param || this._source.param);
      this.message = store.getters.stranslate('error');
      this.type = __WEBPACK_IMPORTED_MODULE_2__utils_transformer__["a" /* default */].fetchResourceName(this._source.error_param || this._source.param);
    }
  }, {
    key: "modifyParamMessages",
    value: function modifyParamMessages(store) {
      if ((this.type == "coupon_ids" || this.paramName.startsWith('coupon')) && this.status != "500") {
        this.paramMessage = store.getters.stranslate('coupon_error');
        this.message = "Invalid Coupon Code";
      }
    }
  }, {
    key: "fillException",
    value: function fillException() {
      if (this._source.errors) {
        this.message = this._source.errors[0].message;
      } else {
        this.message = this._source.message;
      }
      if (this._source.type == "payment") {
        this.type = "payment_method";
      }
    }
  }, {
    key: "isParamException",
    value: function isParamException() {
      return this.exceptionType == "cb_param";
    }
  }, {
    key: "reviewScreenMessage",
    value: function reviewScreenMessage() {
      return this.isParamException() ? this.paramMessage : this.message;
    }
  }]);

  return CbError;
}();

/* harmony default export */ __webpack_exports__["a"] = (CbError);

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Helper = function () {
  function Helper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Helper);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Helper, null, [{
    key: "setWindow",

    //   static downloadWindow;

    value: function setWindow(winName) {
      this.downloadWindow = winName;
    }
  }, {
    key: "getWindow",
    value: function getWindow() {
      return this.downloadWindow;
    }
  }, {
    key: "postTransformRequest",
    value: function postTransformRequest(data, headers) {
      var str = [];
      for (var p in data) {
        if (data.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
        }
      }return str.join("&");
    }
  }, {
    key: "fetchSiteConfig",
    value: function fetchSiteConfig() {
      var matchedContents = window.location.hostname.match(/(.*)\.((.*)\.(.*))/);
      return {
        origin: window.location.origin,
        siteName: matchedContents && matchedContents[1],
        protocol: window.location.protocol.substring(0, window.location.protocol.length - 1),
        domain: matchedContents && matchedContents[2]
      };
    }
  }, {
    key: "is_iPad",
    value: function is_iPad() {
      return !!navigator.userAgent.match(/iPad/);
    }
  }, {
    key: "is_iPhone",
    value: function is_iPhone() {
      return !!navigator.userAgent.match(/iPhone/);
    }
  }, {
    key: "newWindowNotSupported",
    value: function newWindowNotSupported() {
      return navigator.userAgent.match(/iPhone/i) && (navigator.userAgent.match(/FBMD/i) || navigator.userAgent.match(/Instagram/i) || navigator.userAgent.match(/GSA/i));
    }
  }, {
    key: "downloadUrl",
    value: function downloadUrl(url) {
      if (this.is_iPad() || this.is_iPhone()) {
        if (this.downloadWindow) {
          this.downloadWindow.location.href = url;
        }
      } else {
        var iframe = document.createElement('iframe');
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);
      }
    }
  }]);

  return Helper;
}();

/* harmony default export */ __webpack_exports__["a"] = (Helper);

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_cb_client__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_logger__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_cb_storage__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_report_error_js__ = __webpack_require__(47);








window.cbStorage = __WEBPACK_IMPORTED_MODULE_6__utils_cb_storage__["a" /* default */];

var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

var customerHandle = window.cbStorage.getItem("ch");

var logout = function logout() {
  var token = window.cbStorage.getItem("cbt");
  window.cbStorage.removeItem("cbt");
  if (token) {
    __WEBPACK_IMPORTED_MODULE_4__utils_cb_client__["a" /* default */].auth_service.logout({}, { token: token });
  }
};

window.cbTimeout = function (func, timer) {
  window.setTimeout(function () {
    try {
      func();
    } catch (error) {
      window.logger.e(error);
    }
  }, timer);
};

window.logger = new __WEBPACK_IMPORTED_MODULE_5__utils_logger__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5__utils_logger__["a" /* default */].DEBUG, true);
// Vue.use(reportError);


var cbEventHandler = function cbEventHandler(e) {
  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e.data) == "object") {
    // TODO check for origin domain
    if (e.data.key == "cb.logging") {
      logger.addMetaData("ch", customerHandle);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.data).forEach(function (k) {
        if (k != "key") {
          logger.addMetaData(k, e.data[k]);
        }
      });
      logger.logData.logDumper._send();
      logger.logData.meta = {};
    }

    if (e.data.key == "logout") {
      logout();
    }

    if (e.data.key == "cb.preview.email") {
      try {
        window.localStorage.setItem("cb_preview_email", e.data.value);
      } catch (error) {}
    }
  }
};

// Listen to message from another window
eventer(messageEvent, function (e) {
  try {
    cbEventHandler(e);
  } catch (error) {
    // console.log(error);
  }
}, false);

// pass info

var passMessage = function passMessage(message) {
  if (window.parent != self) {
    window.parent.postMessage(message, '*');
  }
};

var imageUrl = initInfo.image && initInfo.image.url;
var brandColor = initInfo.color;
passMessage({ key: "cb.style_config", image_url: imageUrl, color: brandColor });

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tracekit__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tracekit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tracekit__);

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var _oldOnError = Vue.config.errorHandler;
    Vue.config.errorHandler = function (error, vm, info) {
      // Tracekit is rethrowing exception
      try {
        __WEBPACK_IMPORTED_MODULE_0_tracekit___default.a.report(error);
      } catch (error) {}
      if (typeof _oldOnError === 'function') {
        _oldOnError.call(this, error, vm, info);
      }
      console.error(error);
    };
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var isDev = "production" != 'production';

var CbStorage = function () {
  function CbStorage() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CbStorage);

    try {
      window.localStorage;
      if (isDev) {
        this.localStorageEnabled = true;
        return;
      }
      if (window.initInfo) {
        if (!(window.initInfo.is_preview || !window.initInfo.sso_enabled)) {
          this.localStorageEnabled = true;
        }
      }
    } catch (error) {
      this.localStorageEnabled = false;
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CbStorage, [{
    key: 'setItem',
    value: function setItem(key, value) {
      if (this.localStorageEnabled) {
        try {
          window.localStorage.setItem(key, value);
        } catch (error) {
          this.localStorageEnabled = false;
        }
      }
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      if (this.localStorageEnabled) {
        return window.localStorage.getItem(key);
      }
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      if (this.localStorageEnabled) {
        window.localStorage.removeItem(key);
      }
    }
  }, {
    key: 'isLocalStorageEnabled',
    value: function isLocalStorageEnabled() {
      return this.localStorageEnabled;
    }
  }]);

  return CbStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (new CbStorage());

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_cb_error__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tracekit__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tracekit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_tracekit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_log_dumper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue__);












// There are chances of collisions
// same uuid can be generated across different clients
// should rely on site and other params at the request side to differentiate the request
var uuid = function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var LogData = function () {
  function LogData() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, LogData);

    this.version = 1;
    this.server_version = 1;
    this.meta = {};
    this.data = {};
    this.id = uuid();
    this.logDumper = new __WEBPACK_IMPORTED_MODULE_7__models_log_dumper__["a" /* default */](this, 5000);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(LogData, [{
    key: "payload",
    value: function payload() {
      var pl = { type: 'info', info: this.data, id: this.id, meta: this.meta };
      // reset data
      this.data = {};
      return pl;
    }
  }, {
    key: "send",
    value: function send(type) {
      var pl = { type: type, data: this.data, id: this.id, meta: this.meta };
      this.data = {};
      this.meta = {};
      this.logDumper.sendPayLoad(pl);
    }
  }, {
    key: "sendError",
    value: function sendError(error) {
      var pl = { error: error, type: 'error', id: this.id, meta: this.meta };
      this.logDumper.sendPayLoad(pl);
    }
  }, {
    key: "append",
    value: function append(key, value) {
      this.data[key] = this.data[key] || [];
      this.data[key].push(value);
      this.version += 1;
    }
  }, {
    key: "add",
    value: function add(log) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.data, log);
      this.version += 1;
    }
  }]);

  return LogData;
}();

var Logger = function () {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Logger, null, [{
    key: "DEBUG",
    get: function get() {
      return 0;
    }
  }, {
    key: "INFO",
    get: function get() {
      return 1;
    }
  }, {
    key: "WARN",
    get: function get() {
      return 2;
    }
  }, {
    key: "ERROR",
    get: function get() {
      return 3;
    }
  }]);

  function Logger(mode, consoleLogEnabled, sentry) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Logger);

    this.mode = mode;
    this.consoleLogEnabled = consoleLogEnabled;
    this.logData = new LogData();
    if (sentry) {
      this.sentry = sentry;
      __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.config(this.sentry.dsn, this.sentry.options).addPlugin(__WEBPACK_IMPORTED_MODULE_10_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */]).install();
      __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.setTagsContext(this.sentry.tags);
    }
  }

  // hosted page id


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Logger, [{
    key: "addMetaData",
    value: function addMetaData(key, value) {
      this.logData.meta[key] = value;
    }
  }, {
    key: "d",
    value: function d(log) {
      if (this.mode <= Logger.DEBUG) {
        this._l(log);
      }
    }
  }, {
    key: "i",
    value: function i(log) {
      if (this.mode <= Logger.INFO) {
        this._l(log);
      }
    }
  }, {
    key: "a",
    value: function a(key, value) {
      if (this.mode <= Logger.INFO) {
        this._a(key, value);
      }
    }
  }, {
    key: "w",
    value: function w(log) {
      if (this.mode <= Logger.WARN) {
        this._l(log);
      }
    }
  }, {
    key: "e",
    value: function e(error) {
      if (this.mode <= Logger.ERROR) {
        this._e(error);
      }
    }
  }, {
    key: "_l",
    value: function _l(log) {
      if (this.consoleLogEnabled) {
        // console.log(Date.now(), log);
      }

      if ((typeof log === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(log)) === 'object') {
        this.logData.add(log);
      }
    }
  }, {
    key: "_a",
    value: function _a(key, value) {
      this.logData.append(key, value);
    }
  }, {
    key: "_e",
    value: function _e(error) {
      // dont send if the following conditions are met 
      // error is instance of cberror(Meaning server send error)
      // error type is internal (form errors);
      if (!(error instanceof __WEBPACK_IMPORTED_MODULE_5__utils_cb_error__["a" /* default */] && !error.notifyBackend || error.type == "internal")) {
        // trackjs
        // server send
        try {
          // if the error is not an error object, tracekit is rethrowing error
          __WEBPACK_IMPORTED_MODULE_6_tracekit___default.a.report(error);
        } catch (error) {}
        if (this.sentry) {
          __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureException(error);
        }
      }

      if (false) {
        throw error;
      }
    }
  }]);

  return Logger;
}();

__WEBPACK_IMPORTED_MODULE_6_tracekit___default.a.remoteFetching = false;
__WEBPACK_IMPORTED_MODULE_6_tracekit___default.a.report.subscribe(function (errorReport) {
  if (logger.sentry) {
    __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(errorReport));
  }
  logger.logData.sendError(errorReport);
});

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_cb_client__ = __webpack_require__(6);




var LogDumper = function () {
  function LogDumper(logData, timerDuration) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LogDumper);

    this.logData = logData;
    this.inTransit = false;
    this.timerDuration = timerDuration;
    this.isSubmitted = false;
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LogDumper, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.cbTimeout(function () {
        return _this.send();
      }, this.timerDuration);
    }
  }, {
    key: "send",
    value: function send() {
      var _this2 = this;

      if (this.canSend() && this.logData.version != this.logData.server_version) {
        this.inTransit = true;
        this._send().then(function () {
          _this2.inTransit = false;
        }).catch(function (error) {
          console.log(error);
          _this2.inTransit = false;
        });
      }
      window.cbTimeout(function () {
        return _this2.send();
      }, this.timerDuration);
    }
  }, {
    key: "canSend",
    value: function canSend() {
      return !this.inTransit && !this.isSubmitted;
    }
  }, {
    key: "_send",
    value: function _send() {
      this.logData.server_version = this.logData.version;
      return this.sendPayLoad(this.logData.payload());
    }
  }, {
    key: "sendPayLoad",
    value: function sendPayLoad(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__utils_cb_client__["a" /* default */].loggers.info_error({}, payload);
    }
  }]);

  return LogDumper;
}();

/* harmony default export */ __webpack_exports__["a"] = (LogDumper);

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url_helper_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







var urlConfig = __WEBPACK_IMPORTED_MODULE_4__url_helper_js__["a" /* default */].fetchSiteConfig();

var isDev = "production" != "production";
var constructLocalDevDomain = function constructLocalDevDomain(urlConfig) {
    return urlConfig.protocol + "://" + urlConfig.siteName + "." + urlConfig.domain + ":8082";
};

var isLocalDev = function isLocalDev(domain) {
    return domain == "localcb.in";
};

var RestClient = function () {
    function RestClient() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RestClient);

        this.axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
            baseURL: isDev ? constructLocalDevDomain(urlConfig) : urlConfig.origin,
            transformRequest: [function (data, headers) {
                if (headers["Content-Type"] == "application/x-www-form-urlencoded") {
                    var str = [];
                    for (var p in data) {
                        if (data.hasOwnProperty(p) && !(data[p] == undefined || data[p] == null)) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
                        }
                    }
                    return str.join("&");
                } else {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                }
            }]
        });
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(RestClient, [{
        key: "get",
        value: function get(args) {
            return this.axios.request(this._get.apply(this, arguments));
        }
    }, {
        key: "post",
        value: function post(args) {
            return this.axios.request(this._post.apply(this, arguments));
        }
    }, {
        key: "_get",
        value: function _get(path, params) {
            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var config = {
                method: "get",
                params: params,
                url: path,
                headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                    'CbSource': 'viaHp'
                }, headers)
            };

            return config;
        }
    }, {
        key: "_post",
        value: function _post(path, data) {
            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var config = {
                method: "post",
                data: data,
                url: path,
                headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'CbSource': 'viaHp'
                }, headers)
            };

            return config;
        }
    }]);

    return RestClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (RestClient);

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rest_client__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cb_error_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_cb_notification__ = __webpack_require__(11);









var constructQueryParams = function constructQueryParams(allowed, params) {
  return allowed.reduce(function (o, p) {
    if (params[p]) {
      o += p + "=" + params[p] + "&";
    }
    return o;
  }, "");
};

var apis = [{
  name: "gifts",
  actions: [{
    name: "create",
    method: 'post',
    set_locale: true,
    endpoint: "/api/internal/bulk",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json"
    }
  }, {
    name: "claim",
    method: 'post',
    set_locale: true,
    endpoint: "/api/internal/bulk",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json"
    }
  }, {
    name: "get",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/gifts/" + params.id;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json"
    }
  }, {
    name: "list",
    method: "get",
    endpoint: "/api/v2/gifts",
    auth: true
  }, {
    name: "cancel_gift",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "api/v2/gifts/" + params.id + "/cancel";
    },
    auth: true
  }]
}, {
  name: "estimates",
  actions: [{
    name: "create_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/estimates/create_subscription?hp_token=" + params.hp_token;
    },
    set_locale: true
  }, {
    name: "update_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      var query = constructQueryParams(['hp_token'], params);
      return "/api/v2/estimates/update_subscription?" + query;
    },
    auth: true,
    set_locale: true
  }, {
    name: "recurring",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/recurring_subscription_estimate?skip_one_time_coupon=true";
    },
    set_locale: true
  }]
}, {
  name: "paypal",
  actions: [{
    name: "setup_authorization",
    method: "post",
    endpoint: "/api/internal/paypal/setup_authorization",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "fetch_details",
    method: "post",
    endpoint: "/api/internal/paypal/token_info",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "gocardless",
  actions: [{
    name: "create_redirect",
    method: "post",
    endpoint: "/api/internal/gocardless/create_redirect",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "braintree",
  actions: [{
    name: "generate_client_token",
    method: "post",
    endpoint: "/api/internal/braintree/generate_client_token",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "plaid",
  actions: [{
    name: "exchange_token",
    method: "post",
    endpoint: "/api/internal/plaid/exchange_token",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "stripe",
  actions: [{
    name: "retrieve_token",
    method: "post",
    endpoint: "/api/internal/stripe/retrieve_token",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "verify_bank_account",
    method: "post",
    endpoint: "/api/internal/bank_account/verify",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "hosted_pages",
  actions: [{
    name: "get",
    method: "get",
    endpoint: '/api/internal/hosted_page/retrieve',
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "plans",
  actions: [{
    name: "get",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/plans/" + params.id;
    },
    set_locale: true
  }, {
    name: "list",
    method: "get",
    endpoint: "/api/v2/plans",
    set_locale: true
  }, {
    name: "fetch_other_products",
    method: "get",
    endpoint: '/api/internal/products/list',
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "addons",
  actions: [{
    name: "get",
    method: "get",
    endpoint: '/api/v2/addons',
    set_locale: true
  }]
}, {
  name: "payment_sources",
  actions: [{
    name: "get",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/payment_sources/" + params.id;
    },
    set_locale: true,
    auth: true
  }]
}, {
  name: "subscriptions",
  actions: [{
    name: "create",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions?hp_token=" + params.hp_token;
    }
  }, {
    name: "get",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id;
    },
    set_locale: true
  }, {
    name: "update",
    method: "post",
    endpointFn: function endpointFn(params) {
      var query = constructQueryParams(['hp_token', 'resource'], params);
      return "/api/v2/subscriptions/" + params.id + "?" + query;
    },
    auth: true
  }, {
    name: "override_billing_profile",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/override_billing_profile";
    },
    auth: true
  }, {
    name: "update_bulk",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/internal/subscriptions/" + params.id + "?hp_token=" + params.hp_token;
    },
    auth: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "cancel",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/cancel";
    },
    auth: true
  }, {
    name: "reactivate",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/reactivate";
    },
    auth: true
  }, {
    name: "scheduled_changes",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/renewal_estimate?include_delayed_charges=false&use_existing_balances=false";
    },
    auth: true,
    set_locale: true
  }, {
    name: "remove_scheduled_changes",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/remove_scheduled_changes";
    },
    auth: true
  }, {
    name: "remove_scheduled_pause",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/remove_scheduled_pause";
    },
    auth: true
  }, {
    name: "resume_now",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/resume?resume_option=immediately";
    },
    auth: true
  }, {
    name: "pause",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/pause";
    },
    auth: true
  }]
}, {
  name: "customers",
  actions: [{
    name: "get",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id;
    },
    auth: true,
    set_locale: true
  }, {
    name: "update",
    method: "post",
    endpointFn: function endpointFn(params) {
      var query = constructQueryParams(['hp_token'], params);
      return "/api/v2/customers/" + params.id + "?" + query;
    },
    auth: true,
    ignore_locale: true

  }, {
    name: "shipping_address_list",
    method: "get",
    endpoint: "/api/v2/subscriptions",
    auth: true
  }, {
    name: "payment_method_list",
    method: "get",
    endpoint: "/api/v2/payment_sources",
    auth: true
  }, {
    name: "create_card_payment_source",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/payment_sources/create_card?hp_token=" + params.hp_token;
    },
    auth: true
  }, {
    name: "create_bank_account_payment_source",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/payment_sources/create_bank_account?hp_token=" + params.hp_token;
    },
    auth: true
  }, {
    name: "create_payment_source",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/payment_sources/create_using_temp_token?hp_token=" + params.hp_token;
    },
    auth: true
  }, {
    name: "remove_payment_source",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/payment_sources/" + params.id + "/delete";
    },
    auth: true
  }, {
    name: "create_subscription_estimate",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/create_subscription_estimate?hp_token=" + params.hp_token;
    },
    auth: true,
    set_locale: true
  }, {
    name: "create_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/subscriptions?hp_token=" + params.hp_token;
    },
    auth: true
  }, {
    name: "update_billing_info",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/update_billing_info?hp_token=" + params.hp_token;
    },
    auth: true
  }, {
    name: "create_subscription_bulk",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/internal/customers/" + params.id + "/subscriptions?hp_token=" + params.hp_token;
    },
    auth: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "invoices",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/v2/invoices";
    },
    set_locale: true,
    auth: true
  }, {
    name: "download_invoice",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/invoices/" + params.invoiceId + "/pdf";
    },
    auth: true
  }, {
    name: "collect_payment",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/collect_payment";
    },
    auth: true
  }, {
    name: "collect_direct_debit_payment",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/internal/customers/" + params.id + "/collect_payment?hp_token=" + params.hp_token;
    },
    auth: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "field_configs",
  actions: [{
    name: "checkout",
    method: "get",
    ignore_locale: true,
    endpointFn: function endpointFn(params) {
      return "/api/internal/configurations/1/retrieve?type=checkout_new&locale=" + params.locale;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "gift_checkout",
    method: "get",
    ignore_locale: true,
    endpointFn: function endpointFn(params) {
      return "/api/internal/configurations/1/retrieve?type=checkout_gift&locale=" + params.locale;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "portal",
    method: "get",
    ignore_locale: true,
    endpointFn: function endpointFn(params) {
      return "/api/internal/portal_configurations/1/retrieve?locale=" + params.locale;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "retrieve_init_info",
    method: "get",
    ignore_locale: true,
    endpointFn: function endpointFn(params) {
      return "/api/internal/1/retrieve_init_info?locale=" + params.locale;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "style_configs",
  actions: [{
    name: "get",
    method: "get",
    endpoint: "/api/internal/retrieve_init_info",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "comments",
  actions: [{
    name: "create",
    method: "post",
    auth: true,
    endpoint: "/api/v2/comments"
  }]
}, {
  name: "auth_service",
  actions: [{
    name: "verify_otp",
    method: "post",
    endpoint: "/api/internal/ssp_users/verify_otp",
    set_locale: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "verify_password",
    method: "post",
    endpoint: "/api/internal/ssp_users/verify_password",
    set_locale: true,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "check_user",
    method: "post",
    endpoint: "/api/internal/ssp_users/check",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "check_if_existing",
    method: "get",
    endpointFn: function endpointFn(params) {
      return "/api/internal/hosted_pages/" + params.hp_token + "/check_existing";
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "check_user_checkout",
    method: "post",
    endpoint: "/api/internal/ssp_users/check_for_checkout",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "activate_sso_token",
    method: "post",
    endpoint: "/api/internal/ssp_users/activate_token",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "logout",
    method: "post",
    endpoint: "/api/internal/ssp_users/logout",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "clear_preview_cookie",
    method: "post",
    endpoint: "/hp_v3_settings/clear_cookie",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }]
}, {
  name: "loggers",
  actions: [{
    name: "info_error",
    method: "post",
    endpoint: "/api/internal/track_info_error",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      'Content-Type': 'application/json'
    }
  }, {
    name: "tokenization",
    method: "post",
    endpoint: "/hosted_pages/hp_v2_logger",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }, {
    name: "hp_form",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/internal/hosted_pages/" + params.hp_token + "/log?log_type=" + params.log_type;
    },
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      'Content-Type': 'application/json'
    }
  }]
}, {
  name: "vat_service",
  actions: [{
    name: "validate",
    method: "get",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    },
    endpoint: "/hosted_pages/validate_vat"
  }]
}, {
  name: "gateway",
  actions: [{
    name: "retrieve",
    method: "get",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    },
    endpoint: "/api/internal/gateway/retrieve"
  }]
}, {
  name: "cart",
  actions: [{
    name: "create_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/cart_sub_create?hp_token=" + params.hp_token;
    },
    set_locale: true
  }, {
    name: "create_gift_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/gifts/cart_gift_create?hp_token=" + params.hp_token;
    },
    set_locale: true
  }, {
    name: "create_subscription_for_customer",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/cart_sub_create_for_customer?hp_token=" + params.hp_token;
    },
    set_locale: true,
    auth: true
  }, {
    name: "create_gift_subscription_for_customer",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/customers/" + params.id + "/cart_gift_create_for_customer?hp_token=" + params.hp_token;
    },
    set_locale: true,
    auth: true
  }, {
    name: "update_subscription",
    method: "post",
    endpointFn: function endpointFn(params) {
      return "/api/v2/subscriptions/" + params.id + "/cart_sub_update?hp_token=" + params.hp_token;
    },
    set_locale: true,
    auth: true
  }]
}];

var getEndpoint = function getEndpoint(action, params) {
  if (action.endpoint) {
    return action.endpoint;
  }
  if (action.endpointFn) {
    var sanitizedParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(params).reduce(function (o, param) {
      if (params[param]) {
        o[param] = encodeURIComponent(params[param]);
      }
      return o;
    }, {});
    return action.endpointFn(sanitizedParams);
  }
};

var CbClient = function () {
  function CbClient() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CbClient);

    this.restClient = new __WEBPACK_IMPORTED_MODULE_5__rest_client__["a" /* default */]();
    var that = this;
    apis.forEach(function (api) {
      _this[api.name] = {};
      api.actions.forEach(function (action) {
        _this[api.name][action.name] = function (args) {
          var urlEndPoint = getEndpoint(action, Array.prototype.shift.apply(arguments));
          var finalArgs = [].slice.call(arguments);
          finalArgs.unshift(urlEndPoint);
          if (finalArgs.length == 1) {
            finalArgs.push({});
          }
          if (!action.ignore_locale && that.store) {
            var bodyParams = finalArgs[finalArgs.length - 1];
            bodyParams['locale'] = that.store.state.config.init_info_locale;
          }
          var headers = {};
          if (action.headers && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(action.headers).length >= 0) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(headers, action.headers);
          }

          if (that.store) {
            if (that.store.state.auth.page_type == "portal") {
              var jwt = that.store.state.auth.jwt;
              headers['Authorization'] = "Bearer " + jwt;
              headers['CbSource'] = 'viaCp';
            } else {
              if (action.auth && that.store.state.auth.authTokenType != "hp_token") {
                var jwt = that.store.state.auth.jwt;
                headers['Authorization'] = "Bearer " + jwt;
              } else {
                if (that.store.state.auth.hpToken) {
                  var token = that.store.state.auth.hpToken;
                  headers['Authorization'] = "Bearer hp_" + token;
                }
              }
            }
          }

          finalArgs.push(headers);

          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            that.restClient[action.method].apply(that.restClient, finalArgs).then(function (response) {
              return resolve(response.data);
            }).catch(function (error) {
              var cbError = new __WEBPACK_IMPORTED_MODULE_6__cb_error_js__["a" /* default */](error.response.status, error.response.data, undefined, that.store);
              if (error.response.status == 401) {
                window.cbStorage.removeItem('cbt');
                if (that.store) {
                  that.store.dispatch('logout_user', cbError);
                }
                try {
                  if (error.response.config.url.endsWith("/activate_token")) {
                    reject(cbError);
                  }
                } catch (e) {}
              } else {
                reject(cbError);
              }
            });
          });
        };
      });
    });
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CbClient, [{
    key: "syncWithStore",
    value: function syncWithStore(store) {
      this.store = store;
    }
  }]);

  return CbClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (new CbClient());

/***/ })

},[415]);


// WEBPACK FOOTER //
// javascripts/hp_connector.js